import React, { useContext } from 'react';
import './profetionals.css';
import { profetionalsData, profetionalsDataEn } from '../../json/profetionalsData';
import { LanguageContext } from '../../context/LanguageContext/LanguageContext';
import { Link } from 'react-router-dom';
// import { Parallax } from 'react-scroll-parallax';

// Hook para detectar si es móvil
// const useIsMobile = () => {
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     return isMobile;
// };

const Profetionals = () => {
    const { language } = useContext(LanguageContext);
    const data = language === 'ES' ? profetionalsData : profetionalsDataEn;

    // const isMobile = useIsMobile();

    // Parallax props adaptados
    // const parallaxProps = isMobile
    //     ? {
    //         opacity: [0, 2],
    //         scale: [0.95, 1],
    //         shouldAlwaysCompleteAnimation: true,
    //     }
    //     : {
    //         speed: -10,
    //         shouldAlwaysCompleteAnimation: true,
    //     };

    return (
        <div className='container container-profetionals'>
            {/* <Parallax {...parallaxProps}> */}
            <div className='row'>
                <div className='col-md-6'>
                    <div
                        className="img-profetionals"
                        style={{ backgroundImage: `url(${data.image})` }}
                    ></div>
                </div>
                <div className='col-md-6 container-profetionals-text'>
                    <span>{data.title}</span>
                    <h1>{data.mainTitle}</h1>
                    {data.description.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                    <div className='content-profetionals-link'>
                        <Link to={data.link.href} className='btn-profetionals-link btn-general'>
                            {data.link.text}
                        </Link>
                    </div>
                </div>
            </div>
            {/* </Parallax> */}
        </div>
    );
};

export default Profetionals;
